import Backbone from '@polleverywhere/backbone'
import populateSkeletons from '../../../util/populate_skeletons'
import Registration from '@polleverywhere/core/lib/models/registration'

export default class State extends Backbone.Model {
  get defaults () {
    const collection = new Backbone.Collection()
    collection.url = 'api/registrations'
    collection.model = Registration

    return {
      collection,
      item: null,
      user: null
    }
  }

  update () {
    const isEmpty = this.get('collection').isEmpty()

    if (isEmpty) {
      populateSkeletons(this.get('collection'))
    }

    return this.get('collection').fetch()
  }

  async unregister (id) {
    const model = this.get('collection').get(id)
    await model.destroy()
    this.get('collection').remove(model)
    this.set({ item: null })
  }
}
